import React from "react";
import { Box, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";

/** Misma paleta que CardDerechaBolas (Estimates). */
const PRODUCTION_STEPS = [
  { key: "Created", label: "Created", border: "#c896ff" },
  { key: "Offered", label: "Offered", border: "#34afc7" },
  { key: "Accepted", label: "Accepted", border: "#c896ff" },
];

const ACTIVE_FILL = "#00c2a39c";

function StepDot({ checked, border, title, theme }) {
  return (
    <Tooltip title={title} arrow>
      <Box
        component="span"
        sx={{
          width: 12,
          height: 12,
          borderRadius: "50%",
          border: `2px solid ${border}`,
          backgroundColor: checked
            ? ACTIVE_FILL
            : theme.palette.mode === "dark"
              ? theme.palette.background.default
              : "#fff",
          display: "inline-block",
          flexShrink: 0,
          verticalAlign: "middle",
        }}
      />
    </Tooltip>
  );
}

/**
 * Semáforo compacto del ciclo comercial (solo lectura).
 * Solo la bola del estado actual va rellena — igual que Estimates.
 */
const PresupuestoSemaforo = ({ estado = null, compact = true }) => {
  const theme = useTheme();
  const normalized = String(estado || "").trim();

  if (normalized === "MUESTRA") {
    return (
      <Tooltip title="Muestra" arrow>
        <Box
          component="span"
          sx={{
            width: 12,
            height: 12,
            borderRadius: "50%",
            border: "2px solid #34afc7",
            backgroundColor: ACTIVE_FILL,
            display: "inline-block",
          }}
        />
      </Tooltip>
    );
  }

  if (normalized === "Cancelled") {
    return (
      <Tooltip title="Cancelled" arrow>
        <Box
          component="span"
          sx={{
            width: 12,
            height: 12,
            borderRadius: "50%",
            border: `2px solid ${theme.palette.error.main}`,
            backgroundColor: theme.palette.error.main,
            display: "inline-block",
          }}
        />
      </Tooltip>
    );
  }

  const gap = compact ? 0.45 : 0.65;

  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap,
        verticalAlign: "middle",
      }}
    >
      {PRODUCTION_STEPS.map((step) => (
        <StepDot
          key={step.key}
          checked={step.key === normalized}
          border={step.border}
          title={`${step.label}${step.key === normalized ? " (actual)" : ""}`}
          theme={theme}
        />
      ))}
    </Box>
  );
};

export default PresupuestoSemaforo;
